import { render, staticRenderFns } from "./GeneralMessageForm.vue?vue&type=template&id=0b70beec&"
import script from "./GeneralMessageForm.vue?vue&type=script&lang=js&"
export * from "./GeneralMessageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports